<template>
  <div>
    <section-header :fontsize="'h2'"
                    :icon="'$customer'"
                    :title="$t('servicesystem.common_objects.customer.customer')"
                    :invalid="!customer"
                    :leftpad="'ml-4'">
      <template v-slot:button>
        <v-btn v-if="false && isNew && !Creadonly && checkPermission('Actions', 'swapJobCustomer')"
               @click="mode === selectModeKey ? (mode = normalModeKey) : (mode = selectModeKey)"
               class="mr-4"
               :color=" mode === selectModeKey ? 'error' : 'primary'">
          <!-- Remove new mode limit when swap customer is finished -->
          <v-icon :class="isPhoneBool ? '' : 'mr-3'"
                  size="20">{{mode === selectModeKey ? 'mdi-close' : 'mdi-format-list-bulleted'}}</v-icon>
          {{ isPhoneBool ? '' : (mode === selectModeKey ? $t('servicesystem.common_objects.commonterms.cancel') : $t('servicesystem.common_objects.commonterms.select_customer')) }}
        </v-btn>
      </template>
    </section-header>

    <div v-if="mode === selectModeKey">
      <v-card>
        <v-container class="pa-0"
                     fluid>

          <v-row no-gutters
                 class="d-flex px-4 py-2">
            <v-icon class="mr-3">mdi-format-list-bulleted</v-icon>
            <h3 v-text=" $t('servicesystem.common_objects.commonterms.select_customer')" />
            <v-spacer />
            <!--
            <v-btn @click="createnew()"
                   small
                   color="primary">
              <v-icon size="17"
                      class="mr-1">mdi-plus</v-icon>{{$t('servicesystem.common_objects.commonterms.new')}}
            </v-btn>
            -->
          </v-row>

          <v-divider />

          <v-row no-gutters
                 :class="isPhoneBool ? 'conti' : 'conti2'">
            <v-col :cols="PreviewCustomer && !isPhoneBool ? 6 : 12"
                   style="max-height: inherit">
              <customer-list @Close="mode = normalModeKey">
              </customer-list>
            </v-col>
            <v-col v-if="PreviewCustomer"
                   cols="6"
                   class="hei2 fillheight33">
              <preview-customer :id="PreviewCustomer.Id"></preview-customer>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </div>

    <JobThreeColumnPlaceHolder v-if="(!customer && !isNew) || CustomerLoading" />
    <div v-else-if="customer">
      <customer-card :customer="customer"
                     :address="Address"
                     :contact="Contact"
                     :isNew="isNew">
      </customer-card>
    </div>
    <div v-else
         class="pl-3 py-2 error--text">
      {{$t('servicesystem.common_objects.fallbackterms.no_customer')}}
    </div>
  </div>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import CustomerCard from "@/views/job/newjob/cards/customer/CustomerCard2.vue";
import PreviewCustomer from "@/views/job/newjob/cards/customer/PreviewCustomer.vue";
import CustomerList from "@/views/job/newjob/cards/customer/CustomerList.vue";
import SectionHeader from "@/components/ExpancionPanels/Parts/SectionHeader.vue";
import JobThreeColumnPlaceHolder from "@/components/Placeholders/JobThreeColumnPlaceHolder.vue";

export default {
  name: "CustomerCardList",
  props: ["customer", "isNew"],
  components: { SectionHeader, CustomerCard, CustomerList, PreviewCustomer, JobThreeColumnPlaceHolder },
  mixins: [clientAPI],

  data() {
    return {
      mode: this.normalModeKey,
      normalModeKey: "normal",
      editModeKey: "edit",
      selectModeKey: "select",
      Creadonly: false,
    };
  },

  mounted() {
    this.$store.dispatch("JobHub/JobPreview/setPreviewCustomer", null);
  },

  methods: {
    createnew() {
      //TODO: add new method
    },
  },

  computed: {
    PreviewCustomer() {
      return this.$store.getters["JobHub/PreviewCustomer"];
    },
    Customer() {
      return this.$store.getters["JobHub/Customer"];
    },
    CustomerLoading() {
      return this.$store.getters["JobHub/JobCustomer/CustomerLoading"];
    },
    Address() {
      return this.$store.getters["JobHub/CustomerDeliveryAdress"];
    },
    Contact() {
      return this.$store.getters["JobHub/CustomerContact"];
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
.hei2 {
  background-color: rgb(248, 248, 248) !important;
  overflow-y: scroll;
  position: relative;
  max-height: inherit;
}
.conti {
  max-height: calc(100vh - 100px);
}
.conti2 {
  max-height: calc(100vh - 500px);
}
.fillheight33 {
  max-height: inherit;
  min-height: 100%;
}
</style>